import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Input, Button, Form } from 'antd';
import CookieManagementService from '../../../services/CookieManagement.service';
import useNotify from '../../../context/Notification/useNotify';
import { useBlocker } from '../../../util/usePrompt';
import { useNavigate } from 'react-router-dom';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';

export default function ModalAddCategory({
    open,
    handelClose,
    setCagetoryDetail,
    cagetoryDetail,
    domainSelect,
    getCookieCategoryList,
}) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        // await form.resetFields();
        form.setFieldsValue(cagetoryDetail);
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFinish = async (value) => {
        setLoading(true);
        if (!cagetoryDetail?.cookieCategoryId) {
            try {
                const { data } =
                    await CookieManagementService.createCookieCategory({
                        companyId: domainSelect?.companyId,
                        domainId: domainSelect?.domainId,
                        domainUrl: domainSelect?.domainName,
                        categoryNameEn: value?.categoryNameEn,
                        descriptionEn: value?.descriptionEn,
                        categoryNameTh: value?.categoryNameTh,
                        descriptionTh: value?.descriptionTh,
                    });
                if (data?.resultCode === 1) {
                    handelClose();
                    setChange(false);
                    setIsChangeLocation(false);
                    await notify({
                        title: t('common.Success'),
                        description: t('Successfully to save data'),
                    });
                    getCookieCategoryList(
                        domainSelect?.companyId,
                        domainSelect?.domainId
                    );
                } else {
                    if (
                        data?.errorData?.msg?.toLowerCase() ===
                        'this category name en already exist.'
                    ) {
                        form.setFields([
                            {
                                name: 'categoryNameEn',
                                errors: [t('CookieCategory.CategoryNameExist')],
                            },
                        ]);
                    } else if (
                        data?.errorData?.msg?.toLowerCase() ===
                        'this category name th already exist.'
                    ) {
                        form.setFields([
                            {
                                name: 'categoryNameTh',
                                errors: [t('CookieCategory.CategoryNameExist')],
                            },
                        ]);
                    } else {
                        handelClose();
                        setChange(false);
                        await notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to save data'),
                        });
                    }
                }
                setLoading(false);
            } catch (error) {
                if (
                    error?.data?.errorData?.msg.toLowerCase() ===
                    'this category name en already exist.'
                ) {
                    form.setFields([
                        {
                            name: 'categoryNameEn',
                            errors: [t('CookieCategory.CategoryNameExist')],
                        },
                    ]);
                } else if (
                    error?.data?.errorData?.msg.toLowerCase() ===
                    'this category name th already exist.'
                ) {
                    form.setFields([
                        {
                            name: 'categoryNameTh',
                            errors: [t('CookieCategory.CategoryNameExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    setChange(false);
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
                console.log(error);
                setLoading(false);
            }
        } else {
            try {
                const { data } =
                    await CookieManagementService.updateCookieCategory({
                        categoryId: cagetoryDetail?.cookieCategoryId,
                        companyId: domainSelect?.companyId,
                        domainId: domainSelect?.domainId,
                        domainUrl: domainSelect?.domainName,
                        categoryNameEn: value?.categoryNameEn,
                        descriptionEn: value?.descriptionEn,
                        categoryNameTh: value?.categoryNameTh,
                        descriptionTh: value?.descriptionTh,
                    });
                if (data?.resultCode === 1) {
                    handelClose();
                    setChange(false);
                    await notify({
                        title: t('common.Success'),
                        description: t('Successfully to save data'),
                    });
                    getCookieCategoryList(
                        domainSelect?.companyId,
                        domainSelect?.domainId
                    );
                } else {
                    if (
                        data?.errorData?.msg?.toLowerCase() ===
                        'this category name en already exist.'
                    ) {
                        form.setFields([
                            {
                                name: 'categoryNameEn',
                                errors: [t('CookieCategory.CategoryNameExist')],
                            },
                        ]);
                    } else if (
                        data?.errorData?.msg?.toLowerCase() ===
                        'this category name th already exist.'
                    ) {
                        form.setFields([
                            {
                                name: 'categoryNameTh',
                                errors: [t('CookieCategory.CategoryNameExist')],
                            },
                        ]);
                    } else {
                        handelClose();
                        setChange(false);
                        await notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to save data'),
                        });
                    }
                }
                setLoading(false);
            } catch (error) {
                if (
                    error?.data?.errorData?.msg.toLowerCase() ===
                    'this category name en already exist.'
                ) {
                    form.setFields([
                        {
                            name: 'categoryNameEn',
                            errors: [t('CookieCategory.CategoryNameExist')],
                        },
                    ]);
                } else if (
                    error?.data?.errorData?.msg.toLowerCase() ===
                    'this category name th already exist.'
                ) {
                    form.setFields([
                        {
                            name: 'categoryNameTh',
                            errors: [t('CookieCategory.CategoryNameExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    setChange(false);
                    await notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
                console.log(error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (cagetoryDetail?.cookieCategoryId) {
            form.setFieldsValue(cagetoryDetail);
            setChange(false);
        } else {
            form.resetFields();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cagetoryDetail?.cookieCategoryId]);
    return (
        <>
            <Modal
                width={500}
                className="_modal"
                footer={false}
                open={open}
                onCancel={() => {
                    if (change === true) {
                        setOpenChange(true);
                        setIsChangeLocation(true);
                    } else {
                        setChange(false);
                        handelClose();
                        setCagetoryDetail();
                        form.resetFields();
                    }
                }}
                afterClose={() => {
                    if (change === true) {
                        setOpenChange(true);
                        setIsChangeLocation(true);
                    } else {
                        setChange(false);
                        handelClose();
                        setCagetoryDetail();
                        form.resetFields();
                    }
                }}
            >
                <>
                    <div className="text-[22px] text-center my-6">
                        {!cagetoryDetail?.cookieCategoryId
                            ? t('COOKIE.AddCategory')
                            : t('COOKIE.EditCategory')}
                    </div>
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                    >
                        <Form.Item
                            label={t('COOKIE.CategoryNameEN')}
                            name="categoryNameEn"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input
                                placeholder={t('COOKIE.CategoryNameEN')}
                                size="large"
                                showCount
                                maxLength={30}
                                disabled={
                                    cagetoryDetail?.categoryNameEn ===
                                        'Necessary' ||
                                    cagetoryDetail?.categoryNameEn ===
                                        'Analytics' ||
                                    cagetoryDetail?.categoryNameEn ===
                                        'Marketing'
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('COOKIE.DescriptionEN')}
                            name={'descriptionEn'}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                className="bg-[#F4F6FC]"
                                autoSize={{ minRows: 4, maxRows: 6 }}
                                placeholder={t('COOKIE.DescribeDetails')}
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('COOKIE.CategoryNameTH')}
                            name="categoryNameTh"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input
                                placeholder={t('COOKIE.CategoryNameTH')}
                                size="large"
                                showCount
                                maxLength={30}
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('COOKIE.DescriptionTH')}
                            name={'descriptionTh'}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                className="bg-[#F4F6FC]"
                                autoSize={{ minRows: 4, maxRows: 6 }}
                                placeholder={t('COOKIE.DescribeDetails')}
                            />
                        </Form.Item>
                        <div className="flex justify-center items-center py-4 space-x-4">
                            <Button
                                type="primary"
                                size="large"
                                className="w-32"
                                ghost
                                onClick={() => {
                                    if (change ?? true) {
                                        setOpenChange(true);
                                        setIsChangeLocation(true);
                                    } else {
                                        handelClose();
                                        // form.resetFields();
                                        setCagetoryDetail();
                                    }
                                }}
                            >
                                {t('common.Cancel')}
                            </Button>
                            <Button
                                className="w-32"
                                htmlType="submit"
                                size="large"
                                type="primary"
                                loading={loading}
                            >
                                {t('common.Save')}
                            </Button>
                        </div>
                    </Form>
                </>
            </Modal>
            <ModalDiscardChanges
                open={openChange}
                handelOk={() => {
                    if (isChangeLocation) {
                        handelOkLocation();
                        handelClose();
                    } else {
                        handelOk();
                        setChange(false);
                    }
                }}
                handelClose={() => {
                    setOpenChange(false);
                }}
            />
        </>
    );
}
